export default __webpack_public_path__ + "static/PC_3_2-633210055940af9cb1a4dad364e27978.png";